import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class RawAttribute extends Sensor {
  public rawChart: any;
  private rawSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.rawChart = null;
    this.rawSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.rawSensor, position);
      this.rawSensor[position].push([timestamp, element.raw]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredRaw = this.rawSensor.filter(series => series.length > 0);

    const positionNodeRaw = this.rawSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.rawChart = this.getConfigChar(
      'raw',
      this.getChartSeriesNewNode('Sensor', filteredRaw, positionNodeRaw),
      this.getRanges('raw'),
      this.getLimits('raw')
    );
  }

  public hasRawSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.rawSensor.length &&
      this.rawSensor[index].length > 0
    );
  }

  public getRawSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.rawSensor.length) {
      const sensorData = this.rawSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Raw', value: 'raw' }
    ];
  }
}
